export enum BuildMode {
  Development = "development",
  Beta = "beta",
  Production = "production",
}

/**
 * Single source of truth for the build mode. Both builders inject it explicitly via
 * `__BUILD_MODE__` (see vite.config.ts / nuxt.config.ts), so it stays correct under Nuxt,
 * where `import.meta.env.MODE`/`PROD` always resolve to "production" regardless of BUILD_MODE.
 */
export const buildMode = __BUILD_MODE__;

export const isProduction = buildMode === BuildMode.Production;
